import * as React from 'react';
import { Link } from 'react-router-dom';
import ViewEstimation from './ViewEstimation';
import { connect } from 'react-redux';
import { default as DispatchProps, mapDispatchToProps } from '../../../application/core/DispatchProps';
import { RouteComponentProps } from 'react-router';
import UserEstimationRequested from '../../../application/estimations/events/UserEstimationRequested';
import ApplicationState from '../../../application/core/State';

interface MatchParams {
    estimationId: string;
}

interface Props extends RouteComponentProps<MatchParams>, DispatchProps, StateProps {}

interface StateProps {
    customerId: string;
}

class Order extends React.PureComponent<Props> {
    public componentDidMount(): void {
        this.props.dispatch(new UserEstimationRequested(this.props.match.params.estimationId, this.props.customerId));
    }

    public render(): JSX.Element {
        return (
            <ViewEstimation
                goBackLink={
                    <Link to="/estimations-history" className="estimation-history">
                        {' '}
                        &larr; Estimation history
                    </Link>
                }
            />
        );
    }
}

const mapStateToProps = (state: ApplicationState): StateProps => ({
    customerId: state.user.customerId
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Order);



// WEBPACK FOOTER //
// ./src/view/estimations/details/Estimation.tsx